import { AxiosRequestConfig } from "axios";

import { RequestInterceptor } from "@/types/http/request-interceptor";

import { jwtService } from "@/jwt";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon session interceptor.
 * It sets sessionId automatically in request data.
 */
export const falconSessionInterceptor: RequestInterceptor = {
  onFulfilled(
    value: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> | AxiosRequestConfig {
    let data: any;
    try {
      // Error is a string
      data = JSON.parse(value.data);
    } catch {
      data = value.data;
    }
    const requestDataKey = Object.keys(data)[0];
    data[requestDataKey].sessionId = jwtService.payload.falconSessionId;
    value.data = data;
    return value;
  }
};
